import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";
import { ResponseData, ResponsePaging } from "../../nest-responses";
import { RequestCreateWorklocationDto, RequestUpdateWorklocationDto, ResponseWorklocationDto } from "../dto/worklocation.dto";

@Injectable()
export class WorklocationNestApi {
  private service: string = '';
  private model: string = 'workLocation';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }

  public findWorkLocation(payload: { page: number, limit: number }): Observable<ResponsePaging<ResponseWorklocationDto>> {
    const method: string = 'GET';
    const func: string = 'findWorkLocation';
    const params: any = {};
    const urlParams: any = payload
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseWorklocationDto>>(method, url, params, urlParams, body);
  }

  public findOneWorkLocation(payload: { worklocationCode: string }): Observable<ResponseData<ResponseWorklocationDto>> {
    const method: string = 'POST';
    const func: string = 'findOneWorkLocation';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseWorklocationDto>>(method, url, params, urlParams, body);
  }

  public createWorkLocation(payload: RequestCreateWorklocationDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'createWorkLocation';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public updateWorkLocation(payload: RequestUpdateWorklocationDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'updateWorkLocation';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteWorkLocation(payload: { worklocationCode: string }): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'deleteWorkLocation';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }



}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/worklocation.api.ts